export const normalizeTermsContent = (apiData) => {
  if (!apiData || typeof apiData !== 'object') {
    return null;
  }

  const terms = Array.isArray(apiData.terms)
    ? apiData.terms
      .filter(
        (term) => term
            && typeof term.heading === 'string'
            && term.heading.trim() !== ''
            && typeof term.body === 'string'
            && term.body.trim() !== '',
      )
      .map((term) => ({
        heading: term.heading.trim(),
        body: term.body.trim(),
      }))
    : [];

  if (terms.length === 0) {
    return null;
  }

  const title = typeof apiData.title === 'string' && apiData.title.trim() !== ''
    ? apiData.title.trim()
    : '';

  const description = typeof apiData.description === 'string'
    && apiData.description.trim() !== ''
    ? apiData.description.trim()
    : '';

  const acknowledgementLabel = typeof apiData.acknowledgementLabel === 'string'
    && apiData.acknowledgementLabel.trim() !== ''
    ? apiData.acknowledgementLabel.trim()
    : '';

  return {
    title,
    description,
    terms,
    acknowledgementLabel,
  };
};
